import React from "react";
import "./page404.css";

function Page404() {
  return <main className="page404">Page not found</main>;
}

export default Page404;
